import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './column.types';

export const columnSelectors = {
  ...generateResourceSelectors<types.IColumn>((state) => state.resource.column),
};
